module.exports = __webpack_public_path__ + "img/logo_black.ad312136.png";